// extracted by mini-css-extract-plugin
export default {"mindLayoutWrap":"MindLayout__mindLayoutWrap___frbLb"};